import React from 'react';
import { Box, IconButton, InputLabel } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const VideoPlayer = ({ url, label, onEdit }) => {
  if (!url) return null;

  const getVideoId = (url) => {
    // YouTube patterns
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    if (youtubeMatch) {
      return { platform: 'youtube', id: youtubeMatch[1] };
    }

    // Vimeo patterns
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) {
      return { platform: 'vimeo', id: vimeoMatch[1] };
    }

    return null;
  };

  const videoInfo = getVideoId(url);
  if (!videoInfo) return null;

  const embedUrl = videoInfo.platform === 'youtube'
    ? `https://www.youtube.com/embed/${videoInfo.id}`
    : `https://player.vimeo.com/video/${videoInfo.id}`;

  return (
    <Box style={{ width: '100%', marginTop: '16px' }}>
      <Box style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginBottom: '8px'
      }}>
        <InputLabel style={{ 
          color: 'rgba(0, 0, 0, 0.54)',
          fontSize: '16px',
          textAlign: 'left'
        }}>
          {label || 'Video'}
        </InputLabel>
        {onEdit && (
          <IconButton 
            size="small" 
            onClick={onEdit}
            style={{ padding: '4px' }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Box style={{
        position: 'relative',
        paddingBottom: '56.25%', // 16:9 aspect ratio
        height: 0,
        overflow: 'hidden',
        borderRadius: '8px',
        backgroundColor: '#f5f5f5'
      }}>
        <iframe
          title="Product Video"
          src={embedUrl}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none'
          }}
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      </Box>
    </Box>
  );
};

export default VideoPlayer;